import { useQuery } from "vue-query"
import { computed, unref, useContext } from "@nuxtjs/composition-api"

import { GeolocationResponse } from "@/api/query/geolocationsQuery"
import { ApiPaths } from "@/enums"
import { AreaOfInterest } from "@/types/models/AreaOfInterest"
import { Speciality } from "@/types/models/Speciality"
import { User } from "@/types/models/User"
import { CustomQueryHook } from "@/types/vue-query"

export type ProfessionalResponse = {
  professionals: User[]
  maxPageNumber: number
}

export interface FilterProfessionalsParams {
  displayName?: string
  searchKeywords?: string[]
  languages?: Speciality["id"][]
  specialityIds?: Speciality["id"][]
  areasOfInterest?: AreaOfInterest["id"][]
  shareLink?: string
  longitude?: string
  latitude?: string
  location?: GeolocationResponse["description"]
  ids?: User["id"][]
  page?: number
}

export const useProfessionalsQuery: CustomQueryHook<
  FilterProfessionalsParams,
  ProfessionalResponse
> = (params, options) => {
  const { $axios } = useContext()

  return useQuery(
    ["professionalsQuery", params],
    async () => {
      const { data } = await $axios.post<ProfessionalResponse>(
        ApiPaths.GET_PROFESSIONAL,
        unref(
          computed(() =>
            Object.fromEntries(
              Object.entries(params).filter(([_key, value]) => {
                return (
                  (typeof value === "string" && !!value) ||
                  (Array.isArray(value) && value.length) ||
                  (typeof value === "number" && !Number.isNaN(value))
                )
              }),
            ),
          ),
        ),
      )
      return data
    },
    options,
  )
}

export interface QueryParams {
  page?: number
  pageSize?: number
}

export const getProfessionalCustomersQuery: CustomQueryHook<
  QueryParams,
  User[]
> = (params, options) => {
  const { $axios } = useContext()

  return useQuery(
    ["getProfessionalCustomers", params],
    async () => {
      const { data } = await $axios.get<User[]>(
        ApiPaths.GET_PROFESSIONAL_CUSTOMERS,
        {
          params,
        },
      )

      return data
    },
    options,
  )
}
